import { render, staticRenderFns } from "./Arvore.vue?vue&type=template&id=977c4f24"
import script from "./Arvore.vue?vue&type=script&lang=js"
export * from "./Arvore.vue?vue&type=script&lang=js"
import style0 from "./Arvore.vue?vue&type=style&index=0&id=977c4f24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports